import { useMemo } from 'react';
import { useSettings } from '../data/useSettings';
import { useLocale } from '../context/LocaleContext';
import { mileageSettingsOf } from '../domain/studio';
import { expenseSettingsFor } from '../domain/mileage';

// Business Settings' Mileage Log tab (#520) as a trip's save reads it: the
// studio record's `mileage` group, the studio's distance unit — which the
// rate is per — and its currency, all three from the one record. The rule
// that turns these and a trip into an expense is `trip_save_expense` in
// core/src/mileage.rs; this is the one place the web assembles its input, so
// the Mileage Log page and the settings tab's "update the existing entries"
// cannot price a trip differently.
export default function useMileageExpenseSettings() {
  const { settings } = useSettings();
  const { distanceUnit, currency } = useLocale();
  return useMemo(
    () => expenseSettingsFor(mileageSettingsOf(settings), distanceUnit, currency),
    [settings, distanceUnit, currency],
  );
}
